import {Component, Input, OnInit} from '@angular/core';
import {CplItem} from '../../../model/cpl-item.model';
import {CplCycle} from '../../../model/cpl-cycle.model';
import { ModalService } from '../../../modals/modal.service';
import { ComplianceItemHelpersService } from '../../../services/compliance-item-helpers/compliance-item-helpers.service';
import { UserRequestActionState } from 'src/app/requests/enums/user-request-action-state';
import { CycleVerificationActions } from 'src/app/supervision-management/compliance-items/compliance-item/enums/cycle-verification-actions.enum';
import { StateService, UIRouter } from '@uirouter/core';
import { CplUserStatus } from 'src/app/supervision-management/compliance-items/compliance-item/enums/cpl-user-status.enum';
import { FileAttachmentType } from 'src/app/supervision-management/compliance-items/compliance-item/enums/file-attachment-type.enum';
import { VerifyService } from 'src/app/services/verify.service';
import { ToastrService } from 'ngx-toastr';
import { EdlModalSubmit } from 'src/app/modals/edl-modal-submit.component';
import { ModalUserExpiredCycles } from '../modals/expired-cycles.component';
import { VerificationHistory } from 'src/app/model/cpl-verification-history.model';
import { FileAttachment } from 'src/app/model/file-attachment.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PagedResponse, SessionService } from '@edl-development/edl-common';
import { EdlItemPacketUserSummaryDTO } from 'src/app/model/item-packet/edl-item-packet-user-summary-dto.model';
import { CplUserCycleDetails } from 'src/app/model/cpl-user-cycle-details.model';
import { CplRequirement } from 'src/app/model/enum/cpl-requirement.enum';
@Component({
    templateUrl: './compliance-item-cycle.component.html',
    styleUrls:   ['./compliance-item-cycle.component.scss']
})
export class ComplianceItemCycleComponent implements OnInit {
    @Input() details: CplUserCycleDetails;
    @Input() itemPackets: EdlItemPacketUserSummaryDTO[] = [];
    @Input() cycleHistory: PagedResponse;
    @Input() Archived: boolean;
    @Input() ActionRequired: boolean;
    @Input() evidence: Array<FileAttachment>;
    @Input() verificationHistory: Array<VerificationHistory>;

    complianceItem: CplItem;
    userCycle: CplCycle;
    actionState: UserRequestActionState;

    UserRequestActionState = UserRequestActionState;
    CycleVerificationActions = CycleVerificationActions;
    CplRequirement = CplRequirement;

    constructor(
        public complianceItemHelpersService: ComplianceItemHelpersService,
        private stateService: StateService,
        private uiRouter: UIRouter,
        private sessionService: SessionService,
        private verifyService: VerifyService,
        private toastr: ToastrService,
        private modalService: ModalService,
        private ngbModal: NgbModal
    ) {}

    ngOnInit() {
        this.actionState = UserRequestActionState.INFORMATION;
        this.complianceItem = this.details.ComplianceItem;
        this.userCycle = this.details.UserCycle;

        this.modalService.close();

        Promise.resolve(null).then(() => {
            if (this.UserActionRequired()) {        
                this.openExpiredCyclesModal(this.cycleHistory);
            } else if(  
                        (
                            (this.complianceItem.EvidenceRequired === CplRequirement.REQUIRED && this.userCycle.HasAttachments) || this.complianceItem.EvidenceRequired !== CplRequirement.REQUIRED
                        ) 
                        &&
                        (
                            (this.complianceItem.QfmRequired && this.userCycle.HasCompletedQuestionnaire) || !this.complianceItem.QfmRequired
                        ) 
                        && !this.complianceItem.NoTeacherRequirements
                        &&
                        (
                            this.userCycle.UserStatus == CplUserStatus.DEFAULT || this.userCycle.UserStatus == CplUserStatus.EXPIRING || this.userCycle.UserStatus == CplUserStatus.EXPIRED  
                        )
                    ){
                
                this.openConfirmCompleteCycle()
                    .then(() => {
                        this.submitForVerification();
                    },function(dismiss) {
            
                    });
            }
        });
    }

    ngOnDestroy(){
        this.modalService.close();
    }

    toggleActionState(actionState: UserRequestActionState) {
        this.actionState = actionState;
    }

    private UserActionRequired(){
        return this.ActionRequired && this.userCycle.UserID == this.sessionService.user.UserID;
    }

    isCurrentUser(){
        return this.sessionService.user.UserID === this.userCycle.UserID;
    }

    uploadEvidence() {
        this.openUploadEvidence()
            .then(() => {
                this.stateService.reload();
            }, () => {});
    }

    private openExpiredCyclesModal(exCycles: PagedResponse){

        let modalRef = this.ngbModal.open(ModalUserExpiredCycles, {
            size: 'lg',
            backdrop: 'static',
        });
        this.modalService.currentModal = modalRef;

        modalRef.componentInstance.complianceItem = this.complianceItem;
        modalRef.componentInstance.itemCycles = exCycles;
        modalRef.componentInstance.route = this.uiRouter.globals.current.name;
        return modalRef.result;

    }

    private openConfirmCompleteCycle(){
        let modalRef = this.ngbModal.open(EdlModalSubmit, {
            backdrop: 'static',
        });
        return modalRef.result;
    }

    protected openUploadEvidence() {
        const isReadOnly = this.complianceItemHelpersService.isFinalUserStatus(this.userCycle.UserStatus);
        const isDeleteDisabled = (
            this.userCycle.UserStatus !== CplUserStatus.DEFAULT &&
            this.userCycle.UserStatus !== CplUserStatus.EXPIRING &&
            this.userCycle.UserStatus !== CplUserStatus.EXPIRED);
        
        const isUploadDisabled = this.complianceItem.EvidenceRequired === CplRequirement.NONE;
        
        return this.modalService.evidence({ type: FileAttachmentType.COMPLIANCECYCLE, typeId: this.userCycle.CycleID, isReadOnly, isDeleteDisabled, isUploadDisabled });
    }

    completeQuestionnaire(userFormId: string) {
        this.stateService.go('authenticated.questionnaires.user-form.complete', {
            userFormId: userFormId,
            detailId: this.userCycle.CycleID,
            QuestionnaireType: 1,
            masterComplete: !this.isPendingSubmission()
        });
    }

    submitForVerification() {
        this.verifyService
            .submitForVerification(this.userCycle)
            .subscribe(() => {
                this.toastr.success('Submit for Approval successfully completed.');
                this.stateService.reload();
            });
    }

    isPendingSubmission() {
        return this.complianceItemHelpersService.isPendingSubmission(this.userCycle.UserStatus) && this.isCurrentUser();
    }
}